export const FLAG_GETTING_BANKS = 'FLAG_GETTING_BANKS';
export const GET_BANKS = 'GET_BANKS';
export const CLEAR_BANKS = 'CLEAR_BANKS';
export const FLAG_BANK_ACTIVITY = 'FLAG_BANK_ACTIVITY';
export const GET_BANK = 'GET_BANK';
export const CLEAR_BANK = 'CLEAR_BANK';
